import { USER_COUPONS_PROMOS } from './constants'

export const formatAddress = ({ city, state, zipcode }) =>
  `${city}, ${state} ${zipcode}`

export const getDividedPromotionsList = (appliedPromotions = []) =>
  appliedPromotions && appliedPromotions.reduce((acc, item) => {
    const promotionType = item.isUserAppliedPromotion ? USER_COUPONS_PROMOS : item.promotionType

    if (!acc[promotionType]) {
      acc[promotionType] = []
    }

    acc[promotionType].push(item)

    return acc
  }, {})
